import React from "react";
import Button from "../button";

const ModalFooter = (props) => {
    const {
        buttonLabel,
        onButtonClick,
        buttonDisabled,
        buttonID,
        middleButtonLabel,
        middleButtonID,
        middleButtonDisabled,
        onMiddleButtonClick,
        closeButtonLabel,
        closeButtonDisabled,
        onClose,
        closeButtonRef,
        secondaryButtonLabel,
        onSecondaryButtonClick,
        secondaryButtonDisabled,
        secondaryButtonHasPerm = true,
        customHtmlLeft,
        customHtmlMiddle,
        customHtmlRight,
        submitButtonRef,
        closeButtonID,
        isLoading,
        className
    } = props;
    return (
        <footer
            className={className ?? "relative min-h-[4rem] flex flex-wrap flex-row-reverse items-center border-tm-gray-200 border-t px-6 py-2 gap-3 bg-popup rounded-b-lg"}>
            {(!!buttonLabel || !!closeButtonLabel) && (
                <div className="flex gap-2">
                    {!!customHtmlRight && (
                        <div className={"inline-flex"}>{customHtmlRight}</div>
                    )}

                    {!!buttonLabel && (
                        <button
                            ref={submitButtonRef}
                            data-name="submit-button-shortcut"
                            id={buttonID}
                            className={`btn btn-primary mr-2`}
                            onClick={() => {
                                if (!buttonDisabled) {
                                    onButtonClick();
                                }
                            }}
                            disabled={!!buttonDisabled || isLoading}
                        >
                            {buttonLabel}
                        </button>
                    )}

                    {!!customHtmlMiddle && (
                        <div className={"inline-flex mr-2"}>{customHtmlMiddle}</div>
                    )}

                    {!!middleButtonLabel && (
                        <button
                            data-name="submit-button-shortcut"
                            id={middleButtonID}
                            className={`btn btn-primary mr-2`}
                            onClick={() => {
                                if (!middleButtonDisabled) {
                                    onMiddleButtonClick();
                                }
                            }}
                            disabled={!!middleButtonDisabled || isLoading}
                        >
                            {middleButtonLabel}
                        </button>
                    )}

                    {!!closeButtonLabel && (
                        <button
                            data-name="cancel-button-shortcut"
                            id={closeButtonID}
                            className="btn btn-outline"
                            disabled={closeButtonDisabled}
                            onClick={() => {
                                onClose();
                            }}
                            ref={closeButtonRef}
                        >
                            {props.closeButtonLabel}
                        </button>
                    )}
                </div>
            )}

            <span className="flex mr-auto">
                {!!secondaryButtonLabel && (
                    <Button
                        className={'btn btn-outline mr-auto'}
                        onClick={() => {
                            if (!secondaryButtonDisabled) {
                                onSecondaryButtonClick();
                            }
                        }}
                        hasPerm={secondaryButtonHasPerm}
                        disabled={!!secondaryButtonDisabled || isLoading}
                    >
                        {secondaryButtonLabel}
                    </Button>
                )}

                {!!customHtmlLeft && (
                    <div>
                        {customHtmlLeft}
                    </div>
                )}

                {props.children}
            </span>
        </footer>
    )
}

export default ModalFooter;
